export default __webpack_public_path__ + "9e5ad1ccb11f899eb192ac85f4057504.svg";